import React, { useEffect, useState } from "react";

import { View } from "react-native";

import cardStyles from "../cardStyles";
import CloseIcon from "../../../common/dialog/CloseIcon";
import SetupChecklist from "./SetupChecklist";
import CardUtils from "../CardUtils";

export default function SetupChecklistCard({ controller, data = {} }) {
  const [showCard, setShowCard] = useState(false);
  const cardUtils = new CardUtils(controller, data, setShowCard);

  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  return !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { paddingTop: 0 }]}>
        <CloseIcon
          onPress={cardUtils.closeCard}
          style={cardStyles.closeButton}
        />

        <SetupChecklist controller={controller} />
      </View>
    </View>
  );
}
